module.exports = __webpack_public_path__ + "static/media/undefindResult.2b7379b8.png";